function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "url(#dashboard-drafts_svg__paint0_linear)"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.71 30.58L20.129 40C31.097 39.935 39.935 31.097 40 20.129l-9.42-9.42-19.87 19.872z",
  fill: "#000"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.677 10.323H11.613c-.71 0-1.29.58-1.29 1.29v18.064c0 .71.58 1.29 1.29 1.29H23.87l7.097-7.096V11.613c0-.71-.58-1.29-1.29-1.29z",
  fill: "#FFFCF2"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.871 23.871v7.097l7.097-7.097H23.87zm-9.677 2.58h7.096v-1.29h-7.096v1.29zm12.258-5.16H14.193v1.29h12.259v-1.29zm0-3.872H14.193v1.29h12.259v-1.29zm-2.581-3.87h-9.677v1.29h9.677v-1.29z",
  fill: "#D4DAE1"
});
var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dashboard-drafts_svg__paint0_linear",
  x1: 0,
  y1: 40,
  x2: 42.236,
  y2: 2.519,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#009AC0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#00CCBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#60F3AB"
})));
function SvgDashboardDrafts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}
export default __webpack_public_path__ + "fonts/dashboard-drafts-09c3e188dc9a59670215ac2cd08231bb.svg";
export { SvgDashboardDrafts as ReactComponent };